import React from 'react';
import { List } from 'immutable';
const TableContext = React.createContext({
  list: List([]),
  filterRows: () => {
    return null;
  },
  filteredRows: undefined,
  sortState: undefined,
  sortBy: undefined,
  sortDirection: undefined,
  search: ''
});
export default TableContext;